module.exports = "/_next/static/images/gradientBG1-8925417f68eabdd77bc14a2f92518f4e.png";